<template>
  <div>
    <Header />
    <Nav :search="false" :carBtn="false" :phone="false" :title="false" content>
      <div class="carName" slot="content">收银台</div>
    </Nav>
    <div class="paysuccess">
      <img src="../../assets/buycar/paysuccess.png" />
      <div class="title">{{PayInfo.payInfoTxt}}</div>
      <div class="tip1">{{PayInfo.payTipTxt}}</div>
      <div class="first">支付方式： <span>{{PayInfo.payWayTxt}}</span></div>
      <div class="last">支付金额： <span>￥{{(PayInfo.payMoney||0.00).toFixed(2)}}</span></div>
      <div class="buts">
        <van-button color="#0F6EEA" @click.stop="goHome">返回首页</van-button>
        <van-button style="margin-left:50px;color:#999999" @click="goOrder">查看订单</van-button>
      </div>
      <div class="tip2">
        <van-icon name="info-o" />温馨提示：药约約不会以订单异常、系统升级为由要求您点击任何网址链接进行退款操作。</div>
    </div>
    <Footer />
    <!-- 对话框 -->
    <iDialog ref="iDialogref" title="首营资料提醒" msg="下单成功，请尽快提交首营资料，否则存在经营风险" @confirm="confirmDialog" confirmBtnText="去提交"
      cancelBtnText="取消" />
  </div>
</template>

<script>
  import { LinkTypeCode } from '@/dictionary/base.js'
  import iDialog from "@/components/iDialog";
  export default {
    components: {
      iDialog
    },
    data() {
      return {
        PayInfo: {
          payWayTxt: null,
          payInfoTxt: null,
          payTipTxt: null,
        },
      };
    },
    methods: {
      goHome() {
        this.$router.push({ name: LinkTypeCode.Home });
      },
      goOrder() {
        this.$router.push({ name: LinkTypeCode.OrderDetails, query: { orderId: this.PayInfo.orderId } })
      },
      //判断是否首单
      IsFirstOrder() {
        this.getAction("/api_order/Orders/IsfirstOrder").then(res => {
          if (res.IsSuccess) {
            if (res.Data) {
              this.$refs.iDialogref.iShow({}, null);
            }
          }
        });
      },
      confirmDialog() {
        this.$router.push({ name: LinkTypeCode.MyQualifications })
      }
    },
    created() {
      this.PayInfo = this.$route.params;
    },
    mounted() {
      if (!this.PayInfo.orderId) {
        this.$router.push(LinkTypeCode.Home);
      } else {
        // console.log(this.PayInfo)
        switch (this.PayInfo.payWay) {
        case 'wxpay':
          this.PayInfo['payWayTxt'] = "微信支付";
          this.PayInfo['payInfoTxt'] = "订单支付成功";
          this.PayInfo['payTipTxt'] = "我们将尽快为您发货，收货期间请保持手机畅通";
          break;
        case 'alipay':
          this.PayInfo['payWayTxt'] = "支付宝支付";
          this.PayInfo['payInfoTxt'] = "订单支付成功";
          this.PayInfo['payTipTxt'] = "我们将尽快为您发货，收货期间请保持手机畅通";
          break;
        case 'waitpay':
          this.PayInfo['payWayTxt'] = "货到付款";
          this.PayInfo['payInfoTxt'] = "订单提交成功";
          this.PayInfo['payTipTxt'] = "我们将尽快为您发货，收货期间请保持手机畅通";
          break;
        case 'bank':
          this.PayInfo['payWayTxt'] = "银行转账";
          this.PayInfo['payInfoTxt'] = "订单提交成功";
          this.PayInfo['payTipTxt'] = "我们正在核实您的转账情况，核实后将尽快为您发货，收货期间请保持手机畅通";
          break;
        default:
          this.PayInfo['payWayTxt'] = "无";
          break;
        }
        this.$forceUpdate();
        this.IsFirstOrder();
      }
    },
  }
</script>

<style scoped lang="less">
  .paysuccess {
    width: 1200px;
    height: 651px;
    margin: 0 auto;
    margin-top: 30px;
    background: rgba(255, 255, 255, 1);
    border-radius: 1px;
    position: relative;

    img {
      position: absolute;
      top: 91px;
      left: 556px;
    }

    .title {
      position: absolute;
      top: 210px;
      left: 522px;
      font-size: 26px;
      font-weight: 600;
      color: rgba(15, 110, 234, 1);
    }

    .tip1,
    .tip2 {
      width: 100%;
      position: absolute;
      top: 255px;
      left: 0;
    }

    .tip2 {
      top: 532px;
      color: #E47D2F;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        margin-right: 5px;
        margin-top: 1px;
        font-size: 16px;
      }
    }

    >div {
      font-size: 14px;
      color: #777777;
      position: absolute;
      left: 535px;

      >span {
        color: #222222;
      }
    }

    .first {
      top: 305px;
    }

    .last {
      top: 333px;
    }

    .buts {
      width: 100%;
      position: absolute;
      top: 452px;
      left: 0;

      button {
        width: 164px;
        height: 50px;
        color: #ffffff;
        font-size: 16px;
      }
    }
  }
</style>